import { type JSX } from 'react';

export const CloseIcon = (): JSX.Element => {
  return (
    <svg
      fill="currentColor"
      height="100%"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 24 24"
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10.545l5.818-5.818c.402-.401 1.053-.401 1.455 0 .401.402.401 1.053 0 1.455L13.455 12l5.818 5.818c.401.402.401 1.053 0 1.455-.402.401-1.053.401-1.455 0L12 13.455l-5.818 5.818c-.402.401-1.053.401-1.455 0-.401-.402-.401-1.053 0-1.455L10.545 12 4.727 6.182c-.401-.402-.401-1.053 0-1.455.402-.401 1.053-.401 1.455 0L12 10.545z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};
